import createVueApp from '@/common/create_app'

Styxie.Initializers.AdminMlapOnboardings = {
  index: async(props) => {
    const { default: IndexPage } = await import('@/vue_widgets/admin/mlap_onboardings/index.vue')
    createVueApp(IndexPage, { props })
  },
  new: async(props) => {
    const { default: IndexPage } = await import('@/vue_widgets/admin/mlap_onboardings/index.vue')
    createVueApp(IndexPage, { props })
  },
  show: async(props) => {
    const { default: ShowPage } = await import('@/vue_widgets/admin/mlap_onboardings/show/index.vue')
    createVueApp(ShowPage, { props })
  }
}
